const BASE_URL_KEY = "itpmng_jira_base_url";
const TOKEN_KEY = "itpmng_jira_token";
const INSECURE_KEY = "itpmng_jira_insecure";

export interface JiraCreds {
  baseUrl: string;
  token: string;
  insecure: boolean;
}

// App-wide (not per-account) Jira Data Center credential, stored in sessionStorage —
// cleared when the tab closes. The token never leaves the browser except as a
// per-request header to the API proxy; it is never persisted server-side.
export const getJiraCreds = (): JiraCreds | null => {
  const baseUrl = sessionStorage.getItem(BASE_URL_KEY);
  const token = sessionStorage.getItem(TOKEN_KEY);
  if (!baseUrl || !token) return null;
  const insecure = sessionStorage.getItem(INSECURE_KEY) === "true";
  return { baseUrl, token, insecure };
};

export const setJiraCreds = ({ baseUrl, token, insecure }: JiraCreds): void => {
  sessionStorage.setItem(BASE_URL_KEY, baseUrl);
  sessionStorage.setItem(TOKEN_KEY, token);
  sessionStorage.setItem(INSECURE_KEY, insecure ? "true" : "false");
};

export const clearJiraCreds = (): void => {
  sessionStorage.removeItem(BASE_URL_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(INSECURE_KEY);
};
